module.exports = __webpack_public_path__ + "static/img/bg-index.8c98712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/bg-index.jpg
// module id = cIAA
// module chunks = 1